import { render } from "./CardWithBgImage.vue?vue&type=template&id=a54186e4&ts=true"
import script from "./CardWithBgImage.vue?vue&type=script&lang=ts"
export * from "./CardWithBgImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__